<template>

    <Layout
        :header="{ text: '受益人變更', backBtn: { visible: true }, closeBtn: { visible: true, to: { name: routeName.CLOUD_E_COUNTER_HOME } }, }">

        <template #top>
            <div class="w-full max-w-3xl mx-auto p-5">
                <div class="pt-2 pb-6">
                    <Process :steps="['選擇保單', '填寫內容', '確認資料', '手機驗證',]" :index="1"></Process>
                </div>

                <h2 class="font-bold text-2xl">
                    <template v-if="benefitsList?.length === 1">填寫{{ benefitsList[0].title }}受益人資料</template>
                    <template v-else>
                        <p>填寫受益人資料</p>
                        <div class="pt-4 text-base">
                            <p>請選擇欲變更的受益人資料</p>
                            <Checkbox v-for="(option, idx) in changeOptions" :key="idx"
                                v-model:checkedValues="choosedOptions" :value="option.key" :name="'changeOptions'"
                                :text="option.title" class="mb-1 last:mb-0" />
                        </div>
                    </template>
                </h2>
            </div>

            <!-- 保險金類別頁籤 -->
            <div class="pb-8" v-if="benefitsList?.length > 1">
                <div class="border-b">
                    <div class="tabs flex max-w-3xl mx-auto px-4">
                        <button @click="(e) => { setTypeIndex(i); setOrderIndex(0); }"
                            class="tabs__btn py-3 flex-1 relative"
                            :class="{ 'font-bold after:content-[\'\'] after:block after:w-full after:h-[4px] after:absolute after:bottom-0 after:rounded-md after:bg-[#0093C1]': typeIndex === i }"
                            v-for="(item, i) in benefitsList" :key="i">
                            {{ item.title }}
                        </button>
                    </div>
                </div>
            </div>
        </template>

        <template #default="layoutProps">
            <SortableBox :data="currentTypeOrderList" :setData="(data) => { currentTypeData.order = data }"
                :infoBoxVisible="infoBoxVisible" infoBoxTitle="調整受益人順位"
                :infoBoxCloseHandle="(e) => { infoBoxVisible = false; }"
                :methods="{ toChineseNumber, setOrderIndex, updateList, }" v-if="infoBoxVisible" />

            <div class="pb-4 flex justify-between items-center">
                <h3 class="text-xl font-bold">受益人資料</h3>
                <div class=" text-[#0093C1] textsm">
                    <button @click="(e) => { infoBoxVisible = true; }">
                        <svg class="inline-block mb-1" width="12" height="10" viewBox="0 0 12 10" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.666748 5H11.3334M0.666748 9H11.3334M0.666748 1H11.3334" stroke="#0093C1"
                                stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        調整順位
                    </button>
                </div>
            </div>

            <p class="pb-4">
                受益人變更請依順位填寫，若同一順位有 2 位 (含) 以上，請填寫分配比例 (%)
            </p>

            <div class="pb-4 text-nowrap overflow-x-auto -mx-5 px-5">
                <button class="px-4 py-2 mr-2  text-sm rounded-full" v-for="(item, i) in currentTypeOrderList"
                    @click="(e) => { setOrderIndex(i); }"
                    :class="(orderIndex === i) ? 'text-white bg-[#0093C1]' : 'bg-[#D7D8DA]'">
                    {{ item.title }}受益人
                </button>
                <button class="px-4 py-2 text-[#0093C1] bg-[#CCF3FF] text-sm rounded-full" @click="addBeneficiaryOrder">
                    <svg class="inline-block align-middle" width="16" height="16" viewBox="0 0 16 16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 2V14.0001" stroke="#0093C1" stroke-width="1.3" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M14 8H1.99989" stroke="#0093C1" stroke-width="1.3" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                    {{ '第' + toChineseNumber(currentTypeOrderList?.length + 1) + '順位受益人' }}
                </button>
            </div>

            <!-- {{ benefitsList }} -->

            <template v-if="sameOrderList"><!-- 第N順位 -->
                <div class="mb-8">
                    <CaseBox>
                        <!-- 第N順位 同順位N個繼承人 -->
                        <div v-for="(item, i) in sameOrderList" :class="{ 'border-t mt-4 pt-4': i !== 0 }">

                            <button class="w-full flex justify-between"
                                @click="(e) => { item.isOpen = !(item.isOpen) }">
                                <div>
                                    <h5 class="inline-block pr-4 font-bold text-lg">
                                        {{ item.fields.find((item) => item.id === 'name')?.value || '受益人' +
                                            toChineseNumber(i + 1) }}
                                    </h5>
                                    <span class="inline-block py-1 px-2 text-sm text-[#00A59B] bg-[#DFF2F1] rounded-md"
                                        v-show="item.isComplete">填寫完成</span>
                                </div>

                                <div>
                                    <div class="px-2" :class="{ 'rotate-180': !item.isOpen }">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M19 15L12 8L5 15" stroke="#0093C1" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                            </button>

                            <div v-show="item.isOpen">

                                <ul class="list pt-6">
                                    <li v-for="field in (item.fields.filter((x) => x.isVisible !== false))">
                                        <h5 class="list__item__title">{{ field.name }}</h5>

                                        <template v-if="field.type === 'select'">
                                            <SelectBoxV2 :selectOptions="{
                                                selectValue: field.value,
                                                setValue: (data) => {
                                                    field.value = data;
                                                    field.errorMassage = fieldErrorTxt(data, field.name, field.id);
                                                },
                                                placeholder: field.placeholder,
                                                boxData: { boxTitle: field.name, options: getFieldOptions(field), }
                                            }" :changeHandel="validSelect" />
                                            <div class="error-msg">
                                                {{ field.errorMassage }}
                                            </div>
                                        </template>
                                        <template v-else-if="field.type === 'bankAccount'">
                                            <InputBankAccount :value="field.value" :key="inputBankAccountKey"
                                                :changeHandel="() => { field.errorMassage = fieldErrorTxt(field.value, field.name, field.id); }" />
                                            <div class="error-msg">
                                                {{ field.errorMassage }}
                                            </div>
                                        </template>
                                        <template v-else-if="field.type === 'calendar'">
                                            <div class="flex justify-between p-3 w-full border rounded-md cursor-pointer bg-white"
                                                @click="(e) => { field.isOpenCalendar = true; }">
                                                <div class="flex-1">
                                                    <template v-if="field.value">
                                                        {{ field.value }}
                                                    </template>
                                                    <template v-else>{{ field.placeholder || '-' }}</template>
                                                </div>
                                                <div>
                                                    <svg fill="#0093C1" xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 24 24" style="width: 24px; height: 24px;">
                                                        <title>chevron-down</title>
                                                        <path
                                                            d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
                                                    </svg>
                                                </div>
                                            </div>
                                            <Calendar :maxDate="field.maxDate" :minDate="field.minDate"
                                                :beginDate="field.beginDate" v-model:visiblePopup="field.isOpenCalendar"
                                                v-model:userDate="field.value" :isYearROC="field.isYearROC"
                                                :boxTitle="field.placeholder"
                                                :okHandel="() => { field.errorMassage = fieldErrorTxt(field.value, field.name, field.id); }" />
                                            <div class="error-msg">
                                                {{ field.errorMassage }}
                                            </div>
                                        </template>
                                        <template v-else-if="field.type === 'address'">
                                            <div class="flex pb-2">
                                                <div class="w-1/2 pr-1">
                                                    <Multiselect v-model="field.value.city" class="select-base"
                                                        :options="cityInfo.cityList" placeholder="城市" :can-clear="true"
                                                        :can-deselect="false" @select="setCityValue(field.value)"
                                                        @clear="() => setCityValue(field.value)" />
                                                </div>
                                                <div class="w-1/2 pl-1">
                                                    <Multiselect v-model="field.value.cityArea" class="select-base"
                                                        track-by="showText" label="showText" valueProp="showText"
                                                        :options="cityInfo.countyList[field.value.city]" placeholder="區"
                                                        :disabled="!field.value.city" :can-clear="false"
                                                        :searchable="false" :can-deselect="false"
                                                        @select="setCityArea(field.value)" />
                                                </div>
                                            </div>
                                            <input v-model.trim="field.value.address" :disabled="!field.value.cityArea"
                                                inputmode="text" autocomplete="off" type="text" maxlength="62"
                                                placeholder="地址">
                                        </template>
                                        <template v-else>
                                            <!-- <input :type="field.type || 'text'" :placeholder="field.placeholder"
                                                v-model="field.value" :disabled="field.disabled"
                                                @input="(e) => { field.errorMassage = fieldErrorTxt(field.value, field.name, field.id); }" /> -->
                                            <input :type="field.type || 'text'" :placeholder="field.placeholder"
                                                v-model.trim="field.value" :disabled="field.disabled" />
                                            <div class="error-msg">
                                                {{ field.errorMassage }}
                                            </div>
                                        </template>
                                    </li>
                                </ul>

                                <div class="text-center pt-2">
                                    <button class="pt-4 pb-2 text-[#EB4751] text-sm"
                                        @click="(e) => { removeSameOrderSelf(i, layoutProps.method.goLayoutTop); }">
                                        刪除受益人
                                    </button>
                                </div>

                            </div>

                        </div>
                    </CaseBox>

                    <button class="w-full py-4 bg-[#CCF3FF] text-[#0093C1] rounded-md" @click="addSameOrder"
                        v-if="sameOrderList.length > 0">
                        <svg class="inline-block" width="25" height="24" viewBox="0 0 25 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12.5" cy="12" r="10" fill="#0093C1" />
                            <path d="M12.5 7.5V16.4999" stroke="white" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M17 12H8.00009" stroke="white" stroke-width="1.95" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        新增同順位受益人
                    </button>
                </div>
                <div class="mb-8">
                    <h3 class="pb-2 text-xl font-bold ">第{{ toChineseNumber(orderIndex + 1) }}順位受益人分配比例</h3>
                    <p class="pb-4 text-sm">所有受益比例相加需為 100%</p>
                    <CaseBox>

                        <div class="pb-4">
                            <label>
                                <input class="align-middle" type="checkbox" v-model="currentOrderData.isEqual"
                                    @change="changeCheckboxEqual" :disabled="sameOrderList.length === 1" />
                                依人數均分
                            </label>
                        </div>

                        <ul>
                            <li :class="{ 'pt-4': i !== 0 }" v-for="(item, i) in sameOrderList">
                                <h5 class="font-bold pb-2">
                                    {{ item.fields.find((item) => item.id === 'name')?.value || '受益人' +
                                        toChineseNumber(i + 1) }}
                                </h5>
                                <InputPercentage :value="getItemRatio(item.fields)" :setValue="(value) => {
                                    setItem(item.fields, 'ratio', value);
                                }" :disabled="(sameOrderList.length === 1) || currentOrderData.isEqual"
                                    :error="(currentOrderData.isEqual) ? false : isErrorRatio">
                                </InputPercentage>

                            </li>
                        </ul>

                    </CaseBox>
                </div>
            </template>


            <ul class="text-sm text-[#86878F] list-disc pl-6">
                <li v-show="currentTypeData.key !== '005_01'">依契約條款約定，無該項保險金時，雖於受益人欄位填寫受益人姓名仍不生效力。</li>
                <li v-show="currentTypeData.key === '005_01'">
                    本人（要保人）已知悉上述身故保險金受益人如係以身份別指定（如：法定繼承人）或本人不同意填寫受益人之聯絡地址及電話之情形，則以本人最後留存之聯絡方式，作為日後受益人之通知依據。 </li>
                <li v-show="hasForeignCurrency">外幣保單請同時填寫中文姓名及英文姓名或護照上之英文姓名。</li>
            </ul>
            <Loading :is-loading="isLoading" />
        </template>

        <template #bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled="false" @click="goNextPage">下一步</button>
        </template>
    </Layout>

</template>

<script setup>
import '@/assets/cloudCounter/css/style.css';
import { ref, inject, computed, watch, onMounted, reactive } from 'vue';

import Layout from '@/components/cloudCounter/Layout.vue';
import Process from '@/components/cloudCounter/Process.vue';
import CaseBox from '@/components/cloudCounter/CaseBox.vue';
import SelectBoxV2 from '@/components/cloudCounter/SelectBox.v2.vue';
import InputBankAccount from '@/components/cloudCounter/InputBankAccount.vue';
import InputPercentage from '@/components/cloudCounter/InputPercentage.vue';
import SortableBox from '@/components/cloudCounter/SortableBox.vue';
import routeName from '@/router/constant';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { postRelation4, getInfo, postSubmit } from '@/apis/beneficiaryChange';
import Loading from '@/components/Loading.vue';
import { beneficiaryField, beneficiaryVo, inputFields } from './beneficiaryField';
import Calendar from '@/components/cloudCounter/Calendar.vue';
import { integer, IDnumber } from '@/utils/rules/customRules.js';
import { openPopup, openPopupCatchMessage } from '@/utils/vfmUtils';
import Multiselect from '@vueform/multiselect';
import { getCityInfo } from '@/apis/applicantChange';
import Checkbox from '@/components/checkboxs/Checkbox.vue';

const router = useRouter();
const route = useRoute();
const store = useStore();
const code = route.meta.code;
const $vfm = inject('$vfm');
const relationList = ref([]);
const isLoading = ref(false);
const cityInfo = reactive({
    cityList: [],
    countyList: [],
});
const hasForeignCurrency = ref(false);

function toChineseNumber(n) {
    if (!Number.isInteger(n) && n < 0) {
        throw Error('請輸入數字');
    }

    const digits = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    const positions = ['', '十', '百', '千', '萬', '十萬', '百萬', '千萬', '億', '十億', '百億', '千億'];
    const charArray = String(n).split('');
    let result = '';
    let prevIsZero = false;
    //处理0  deal zero
    for (let i = 0; i < charArray.length; i++) {
        const ch = charArray[i];
        if (ch !== '0' && !prevIsZero) {
            result += digits[parseInt(ch)] + positions[charArray.length - i - 1];
        } else if (ch === '0') {
            prevIsZero = true;
        } else if (ch !== '0' && prevIsZero) {
            result += '零' + digits[parseInt(ch)] + positions[charArray.length - i - 1];
        }
    }
    //处理十 deal ten
    if (n < 100) {
        result = result.replace('一十', '十');
    }
    return result;
}

const inputBankAccountKey = ref(0); // InputBankAccount 元件的key
const typeIndex = ref(0);  //保險金類別 index
const setTypeIndex = (i) => {
    typeIndex.value = i;
    inputBankAccountKey.value += 1; // 更新InputBankAccount元件的key，強制刷新(因每個受益人的帳號可能不同，分行選單要再依各別的總行去重抓資料)
};

//前端受益人總清單
const benefitsList = ref([]);
//選擇變更的種類
const changeOptions = ref([]);
const choosedOptions = ref([]);
//是否為身故後年金
const isDeathAnnuity = ref(false);

//後端info假資料
const testInfo = ref({
    "beneficiaries": [
        "Y",
        "Y",
        "Y"
    ],
    "beneficiary01": [
        {
            "searchCode": "",
            "order": "01",
            "isDivide": "N",
            "dividKind": "",
            "dividKindDesc": "",
            "name": "某A",
            "engName": "",
            "id": "A123456789",
            "birthday": "55/05/05",
            "country": "中華民國",
            "relation": "法定繼承人",
            "percent": "72",
            "proportionDenominator": "100",
            "bankNo": "006",
            "swiftCode": "",
            "branchCode": "0060095",
            "branchName": "合作金庫商業銀行永和分行",
            "bankName": "合作金庫商業銀行",
            "account": "555"
        },
        {
            "searchCode": "",
            "order": "01",
            "isDivide": "N",
            "dividKind": "",
            "dividKindDesc": "",
            "name": "某B",
            "engName": "",
            "id": "B123456789",
            "birthday": "55/05/05",
            "country": "中華民國",
            "relation": "法定繼承人",
            "percent": "28",
            "proportionDenominator": "100",
            "bankNo": "006",
            "swiftCode": "",
            "branchCode": "0060095",
            "branchName": "合作金庫商業銀行永和分行",
            "bankName": "合作金庫商業銀行",
            "account": "555"
        },
        {
            "searchCode": "",
            "order": "02",
            "isDivide": "N",
            "dividKind": "",
            "dividKindDesc": "",
            "name": "某C",
            "engName": "",
            "id": "C123456789",
            "birthday": "55/05/05",
            "country": "中華民國",
            "relation": "本人",
            "percent": "100",
            "proportionDenominator": "100",
            "bankNo": "006",
            "swiftCode": "",
            "branchCode": "0060095",
            "branchName": "合作金庫商業銀行永和分行",
            "bankName": "合作金庫商業銀行",
            "account": "555"
        }
    ],
    "beneficiary02": [
        {
            "searchCode": "005_02",
            "order": "01",
            "isDivide": "",
            "dividKind": "",
            "dividKindDesc": "",
            "name": "簡ＸＸ",
            "engName": "",
            "id": "A124606336",
            "birthday": "55/05/05",
            "country": "中華民國",
            "relation": "本人",
            "percent": "100",
            "proportionDenominator": "100",
            "bankNo": "006",
            "swiftCode": "",
            "branchCode": "0060095",
            "branchName": "合作金庫商業銀行永和分行",
            "bankName": "合作金庫商業銀行",
            "account": "555"
        }
    ],
    "beneficiary03": [
        {
            "searchCode": "005_03",
            "order": "01",
            "isDivide": "N",
            "dividKind": "",
            "dividKindDesc": "",
            "name": "簡ＸＸ",
            "engName": "",
            "id": "A124606336",
            "birthday": "55/05/05",
            "country": "中華民國",
            "relation": "本人",
            "percent": "100",
            "proportionDenominator": "100",
            "bankNo": "006",
            "swiftCode": "",
            "branchCode": "0060095",
            "branchName": "合作金庫商業銀行永和分行",
            "bankName": "合作金庫商業銀行",
            "account": "555"
        }
    ]
})

//單受益人欄位(新增收益人用)
const singleData = JSON.stringify(beneficiaryField);

const orderIndex = ref(0);  //第N順位受益人
const setOrderIndex = (index) => {
    orderIndex.value = index;
}

//新增受益人順位
const addBeneficiaryOrder = () => {
    const orderList = currentTypeOrderList.value;
    let _singleData = JSON.parse(singleData);

    _singleData = { ..._singleData, key: currentTypeData.value.key }

    _singleData.fields.forEach((item) => {
        if (item.id === 'ratio') {
            item.value = '100.00';
        }
    });

    let filteredInputs = _singleData.fields.filter(e => e.showType.includes(currentTypeData.value.key))
    filteredInputs = filteredInputs.filter(item => !(item.id === 'engName' && !hasForeignCurrency.value))
    _singleData = { ..._singleData, fields: filteredInputs }


    orderList.push({
        title: '第' + toChineseNumber((orderList.length + 1)) + '順位',
        isEqual: false,              //均等的
        order: [_singleData]         //同順位
    });

    orderIndex.value = orderList.length - 1;
}

//保險金種類
const currentTypeData = computed(() => benefitsList.value[typeIndex.value] || []);
const currentTypeOrderList = computed(() => currentTypeData.value?.order || []);

//第N順位受益人
const currentOrderData = computed(() => {
    const temp = currentTypeOrderList.value;
    return temp === undefined ? [] : temp[orderIndex.value];
});

//同順位受益人清單
const sameOrderList = computed(() => ((currentOrderData.value)?.order));

//新增同順位受益人
const addSameOrder = (e) => {
    let _singleData = JSON.parse(singleData);
    let filteredInputs = _singleData.fields.filter(e => e.showType.includes(currentTypeData.value.key))
    filteredInputs = filteredInputs.filter(item => !(item.id === 'engName' && !hasForeignCurrency.value))
    _singleData = { ..._singleData, fields: filteredInputs, key: currentTypeData.value.key }
    sameOrderList.value.push(_singleData);
};

const setItem = (data, id, value) => {
    if (data) {
        data.forEach((item) => {
            if (item.id === id) {
                // console.log('object');
                item.value = value;
            }
        });
    }
};

const getItem = (data, id) => (data.find((item) => item.id === id)?.value || '');
const getItemRatio = (data) => (getItem(data, 'ratio'));
// const getItemOpen = (data) => (getItem(data, 'open'));


// 更新名稱、分配比例、濾掉同順位空陣列
const updateList = (_ary) => {
    if (_ary && _ary.length > 0) {

        let hasRemove = false;
        _ary.forEach((item, i, arr) => {

            if (item.order?.length <= 0) {              // 判斷同順位無受益人，移除此順位
                arr.splice(i, 1);
                hasRemove = true;
            }
            else if (item.order?.length === 1) {        // 判斷同順位只有一位受益人
                item.isEqual = false;                   // 取消均分
                setItem(item.order[0].fields, 'ratio', '100.00');
            }
            else {
                if (item.isEqual) {                     // 判斷已勾選均分
                    item.order.forEach((personal) => {
                        setItem(personal.fields, 'ratio', '均分');
                    });
                }
            }

        });

        if (hasRemove) {
            //更新順位
            _ary.forEach((item, i) => {
                item.title = '第' + toChineseNumber(i + 1) + '順位';
            });
        }
    }
};

// 移除受益人自己
const removeSameOrderSelf = (index, scrollToHandle) => {
    if (index >= 0) {

        (sameOrderList.value).splice(index, 1);

        if (sameOrderList.value.length === 0) {
            const newOrderIndex = (orderIndex.value) - 1;
            orderIndex.value = (newOrderIndex <= 0) ? 0 : newOrderIndex;
        }

        // 更新
        updateList(currentTypeData.value.order);

        if (typeof scrollToHandle === 'function') {
            scrollToHandle(0, 260);
        }

    }
};


//加總未符合100%
const isErrorRatio = computed(() => {
    let sum = 0;
    (sameOrderList.value).forEach(data => {
        sum += parseFloat(getItemRatio(data.fields));
        // console.log(sum);
    });
    return (sum !== 100.00);
});


//平均分配
const changeCheckboxEqual = (e) => {
    sameOrderList.value.forEach((item) => {
        setItem(item.fields, 'ratio', (e.target.checked) ? '均分' : '');
    });
}

//檢查項目是否完成
const checkComplete = (data) => {
    if (data) {
        let _isComplete = true;
        for (let i = 0; i < data.fields.length; i++) {
            const item = data.fields[i];
            if (item.isVisible !== false) {

                const _val = item.value;
                //銀行帳號非必填，有些沒分行，所以只檢查當有填寫總行時，戶碼需必填
                const isObjectEmpty = typeof _val === 'object' && (_val.bankCode !== '' && _val.bankAccount === '');
                const isStringEmpty = typeof _val === 'string' && (_val === '');

                if (isObjectEmpty || isStringEmpty || item.errorMassage !== '') {
                    _isComplete = false;
                    break;
                }
            }
        }
        // console.log(_isComplete);
        data.isComplete = _isComplete;
    }
}

//文字彈窗
const infoBoxVisible = ref(false);

// const isDisabledNextPage = computed(() => {
//     let isOK = true;
//     if (changeOptions.value.length > 1 && choosedOptions.value.length <= 0) {
//         return true;
//     }
//     // 單種保險金檢核
//     if (changeOptions.value?.length <= 1) {
//         const typeData = benefitsList.value[0] || [];
//         if (typeData.length < 1 || typeData.order?.length < 1) return true;
//         for (const orderData of typeData.order) {           //第N順位  
//             if (!orderData.isEqual) { // 非均分要檢查比例是否加總100
//                 let sum = 0;
//                 (orderData.order).forEach(data => {
//                     sum += parseFloat(getItemRatio(data.fields));
//                 });
//                 if (sum !== 100.00) {
//                     isOK = false;
//                     break;
//                 }
//             }
//             for (const personalData of orderData.order) {   //同順位
//                 let realtion = personalData.fields.find(field => field.id === 'relation')?.value;
//                 for (const field of personalData.fields) {  //檢查每一項欄位
//                     if (field.id === 'mobile') { continue; }
//                     if (realtion === '法定繼承人' && (field.id === 'id' || field.id === 'birthday' || field.id === 'engName')) { continue; }
//                     if (
//                         (typeof field.value === 'string' && field.value === '') ||
//                         //銀行帳號非必填，有些沒分行，所以只檢查當有填寫總行時，戶碼需必填
//                         (typeof field.value === 'object' && (field.value.bankCode !== '' && field.value.bankAccount === '')) ||
//                         //地址非必填
//                         (typeof field.value === 'object' && (Boolean(field.value.city) && field.value.address === '')) ||
//                         //欄位有錯誤訊息
//                         field.errorMassage !== ''
//                     ) {
//                         isOK = false;
//                         break;
//                     }
//                 }
//             }
//         }
//     } else {
//         // 多種保險金檢核
//         let needValidList = benefitsList.value.filter(e => choosedOptions.value.includes(e.key))
//         for (const typeData of needValidList) {                //保險類別
//             if (typeData.order.length === 0) {
//                 isOK = false;
//                 break;
//             } else {
//                 for (const orderData of typeData.order) {           //第N順位  
//                     if (!orderData.isEqual) { // 非均分要檢查比例是否加總100
//                         let sum = 0;
//                         (orderData.order).forEach(data => {
//                             sum += parseFloat(getItemRatio(data.fields));
//                         });
//                         if (sum !== 100.00) {
//                             isOK = false;
//                             break;
//                         }
//                     }
//                     for (const personalData of orderData.order) {   //同順位
//                         let realtion = personalData.fields.find(field => field.id === 'relation')?.value;
//                         for (const field of personalData.fields) {  //檢查每一項欄位
//                             if (field.id === 'mobile') { continue; }
//                             if (realtion === '法定繼承人' && (field.id === 'id' || field.id === 'birthday' || field.id === 'engName')) { continue; }
//                             if (
//                                 (typeof field.value === 'string' && field.value === '') ||
//                                 //銀行帳號非必填，有些沒分行，所以只檢查當有填寫總行時，戶碼需必填
//                                 (typeof field.value === 'object' && (field.value.bankCode !== '' && field.value.bankAccount === '')) ||
//                                 //地址非必填
//                                 (typeof field.value === 'object' && (Boolean(field.value.city) && field.value.address === '')) ||
//                                 //欄位有錯誤訊息
//                                 field.errorMassage !== ''
//                             ) {
//                                 isOK = false;
//                                 break;
//                             }
//                         }
//                     }
//                 }
//             }
//         }
//     }

//     return !isOK;
// });

// const isDisabledNextPage = computed(() => {
//     let isOK = true;
//     for (const typeData of benefitsList.value) {                //保險類別
//         if (typeData.order.length === 0) {
//             isOK = false;
//             break;
//         } else {
//             for (const orderData of typeData.order) {           //第N順位  
//                 if (!orderData.isEqual) { // 非均分要檢查比例是否加總100
//                     let sum = 0;
//                     (orderData.order).forEach(data => {
//                         sum += parseFloat(getItemRatio(data.fields));
//                     });
//                     if (sum !== 100.00) {
//                         isOK = false;
//                         break;
//                     }
//                 }
//                 for (const personalData of orderData.order) {   //同順位
//                     for (const field of personalData.fields) {  //檢查每一項欄位
//                         if (field.id === 'mobile') { continue; }
//                         if (
//                             (typeof field.value === 'string' && field.value === '') ||
//                             //銀行帳號非必填，有些沒分行，所以只檢查當有填寫總行時，戶碼需必填
//                             (typeof field.value === 'object' && (field.value.bankCode !== '' && field.value.bankAccount === '')) ||
//                             //地址非必填
//                             (typeof field.value === 'object' && (field.value.city !== '' && field.value.address === '')) ||
//                             //欄位有錯誤訊息
//                             field.errorMassage !== ''
//                         ) {
//                             isOK = false;
//                             break;
//                         }
//                     }
//                 }
//             }
//         }
//     }
//     return !isOK;
// });

const getSelectItems = () => {
    // 原本：生存('005_01')、滿期('005_02')、身故('005_03')
    // 正確：身故('005_01')、生存('005_02')、滿期('005_03')
    // 後端接收：[生存保險金 Y , 滿期保險金	Y ,身故 Y]
    const types = ['005_01', '005_02', '005_03'];
    const returnArr = [];
    types.forEach(e => {
        let result = "";
        if (choosedOptions.value.includes(e)) {
            result = "Y";
        }
        returnArr.push(result);
    })
    return returnArr;
}

const goNextPage = () => {
    // console.log(benefitsList.value);

    let errorMsg = validateForms();
    if (errorMsg) {
        openPopup(errorMsg);
        return;
    }

    const relations = [];
    benefitsList.value.forEach(i => i.order?.forEach(o => {
        o.order?.forEach(p => {
            let relation = p.fields.find(f => f.id === 'relation')?.value;
            relations.push(relation);
        })
    }))
    const oriRelation = relationList.value.map(r => r.label);
    let result = relations.find(r => !oriRelation.includes(r));
    if (result) {
        openPopup(`變更後受益人無法提供線上保單服務功能，請通知您的服務人員協助辦理，或洽詢免付費服務電話 0809-000-550，造成您的不便，敬祈見諒！`);
        return;
    }

    const selectItem = getSelectItems();
    const request = {
        beneficiary01: setApiData(benefitsList.value.find(x => x.key === '005_01')),
        beneficiary02: setApiData(benefitsList.value.find(x => x.key === '005_02')),
        beneficiary03: setApiData(benefitsList.value.find(x => x.key === '005_03')),
        selectItem,
    };

    isLoading.value = true;
    postSubmit(request).then(res => {
        const storeData = {
            benefitsList: benefitsList.value,
            apiData: request,
            choosedOptions: choosedOptions.value,
            changeOptions: changeOptions.value,
            isDeathAnnuity: isDeathAnnuity.value,
            hasForeignCurrency: hasForeignCurrency.value,
        }
        store.dispatch('services/setChangeItemsResult', { code, value: storeData });
        if (res.data?.aml) {
            $vfm.show({
                component: 'DialogBase',
                params: {
                    title: '您暫時無法線上辦理申請',
                    content: '您的保單暫時無法提供線上保單服務，請通知您的服務人員協助辦理，或洽詢免付費服務電話0809-000-550，造成您的不便，敬祈見諒。',
                    confirmButton: '確定',
                    cancelButton: null,
                    closeicon: false,
                },
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                    },
                },
            });
        } else {
            router.push({ name: routeName.CLOUD_E_COUNTER_CONFIRM });
        }
    }).catch(ex => {
        openPopupCatchMessage(ex);
    }).finally(() => {
        isLoading.value = false;
    })
};

function getFieldOptions(field) {
    if (field.id === 'relation') {
        // 僅滿期保險金可選本人
        let filterList = relationList.value.filter(i => !(i.value === '5' && currentTypeData.value?.key === '005_01'))
        // 僅身故保險金/身故後年金，可選法定繼承人
        filterList = filterList.filter(i => !(i.value === '4' && currentTypeData.value?.key !== '005_01'))
        return filterList.map(i => i.label);
    } else {
        return field.options;
    }
}

const fieldErrorTxt = (value, fieldName, fieldId) => {
    let msg = '';
    if (fieldId === 'accountGroup') {
        msg = integer(value.bankAccount, '請輸入數字!') || '';
    } else if (fieldId === 'id') {
        msg = IDnumber(value) || '';
    } else {
        msg = (!value || !value.length) ? `${fieldName}未填寫，請確認！` : '';
    }
    return msg;
};

function setApiData(beneficiary) {
    let beneficiaryData = [];
    beneficiary?.order.forEach((item, i) => {
        const order = (i + 1).toString().padStart(2, '0');
        item.order.forEach((o) => {
            const temp = JSON.parse(JSON.stringify(beneficiaryVo));
            temp.order = order;
            temp.isDivide = item.isEqual ? 'Y' : 'N';
            o.fields.forEach(f => {
                if (f.id === 'accountGroup') {
                    const bankCodeTemp = f.value.bankCode.split(' ');
                    if (hasForeignCurrency.value) {
                        temp.swiftCode = bankCodeTemp[0] || '';
                        bankCodeTemp.shift();
                        temp.bankName = bankCodeTemp.join(' ') || '';
                    } else {
                        const bankBranchTemp = f.value.bankBranch.split(' ');
                        temp.bankNo = bankCodeTemp[0] || '';
                        temp.bankName = bankCodeTemp[1] || '';
                        temp.branchCode = bankBranchTemp[0] || '';
                        temp.branchName = bankBranchTemp[1] || '';
                    }
                    temp.account = f.value.bankAccount;
                }
                else if (f.id === 'ratio') {
                    if (temp.isDivide === 'Y') {
                        // 均分: 分母為人數，分子給空
                        temp.percent = '';
                        temp.proportionDenominator = item.order.length + '';
                    } else {
                        temp.percent = f.value;
                        //f.value = f.value + '%';
                        temp.proportionDenominator = '100';
                    }
                }
                else if (f.id === 'addressGroup') {
                    temp.city = f.value.city || '';
                    temp.cityArea = f.value.cityArea;
                    if (f.value.cityArea) {
                        let cityArr = f.value.cityArea.split(" ");
                        temp.zip = cityArr[0];
                        temp.cityArea = cityArr[1];
                    }
                    temp.address = f.value.address;
                }
                else if (f.id === 'relation') {
                    // label 找回 value
                    temp.relation = relationList.value.find(e => e.label === f.value)?.value || ""
                }
                else {
                    temp[f.id] = f.value;
                }
            })
            beneficiaryData.push(temp);
        })
    });
    return beneficiaryData;
};

// mapping inputFields
function mappingInputFields(inputFields, data) {
    let filteredInputFields = inputFields.filter(item => !(item.id === 'engName' && !hasForeignCurrency.value))
    // searchCode: "005_01"
    filteredInputFields = filteredInputFields.filter(e => e.showType.includes(data.searchCode))
    return filteredInputFields.map(item => {
        if (data[item.id] !== undefined) {
            //如果 data中有對應的 id 鍵，更新 inputFields 中的值
            return {
                ...item, value: data[item.id],
                //errorMassage: data[item.id] !== '' ? '' : `${item.name}未填寫，請確認！` 
            };
        } else if (item.id === 'accountGroup') {
            return {
                ...item, value: {
                    bankCode: data.bankNo ? `${data.bankNo} ${data.bankName}` : '',
                    bankBranch: data.branchCode ? `${data.branchCode} ${data.branchName}` : '',
                    // 若為外幣保單直接清空銀行帳號
                    bankAccount: hasForeignCurrency.value ? '' : data.account
                },
                //errorMassage: (data.bankNo !== '' && data.account === '') ? '帳戶號碼未填寫，請確認！' : ''
            };
        } else if (item.id === 'ratio') {
            return {
                ...item, value: data.percent
            };
        } else if (item.id === 'addressGroup') {
            return {
                ...item, value: {
                    ...item.value
                },
            }
        }
        return { ...item };
    });
}

// 設定第N順位的資料to前端DOM
function setOrderData(beneficiaryData) {
    return beneficiaryData.reduce((acc, curr) => {
        const id = curr.order;
        const isEqual = curr.isDivide === 'Y' ? true : false
        const orderData = {
            isComplete: false,
            isOpen: true,
            fields: mappingInputFields(inputFields, curr),
            apiData: curr
        };
        checkComplete(orderData);

        // 查找是否已有該 order 的分组
        let group = acc.find(item => item.id === id);
        if (!group) {
            group = {
                id: id,
                title: '第' + toChineseNumber(parseInt(id)) + '順位',
                isEqual: isEqual,
                order: []
            };
            acc.push(group);
        }
        group.order.push(orderData);

        return acc;
    }, []);
}


const validSelect = () => {

    let needValidList = benefitsList.value.filter(e => choosedOptions.value.includes(e.key))
    for (const typeData of needValidList) {                //保險類別
            for (const orderData of typeData.order) {           //第N順位  
                for (const personalData of orderData.order) {   //同順位
                    let realtion = personalData.fields.find(field => field.id === 'relation')?.value;
                    for (const field of personalData.fields) {  //檢查每一項欄位
                        if (field.id === 'mobile') { continue; }
                        if (realtion === '法定繼承人' && (field.id === 'id' || field.id === 'birthday' || field.id === 'engName' || field.id === 'name')) { 
                            // 清空ID欄位
                            if(field.id === 'id') {
                                field.value = '';
                                field.disabled = true;
                            }
                            // 清空英文名稱
                            if(field.id === 'engName') {
                                field.value = '';
                                field.disabled = true;
                            }
                            // 清空生日
                            if(field.id === 'birthday') {
                                field.value = '';
                                field.disabled = true;
                            }
                            // 姓名帶入預設值
                            if(field.id === 'name') {
                                field.value = '法定繼承人';
                                //field.disabled = true;
                            }
                            continue; 
                        } else if (realtion !== '法定繼承人' && (field.id === 'id' || field.id === 'birthday' || field.id === 'engName' || field.id === 'name')) { 
                            field.disabled = false;
                        }
                    }
                }
            }
    }
 }




const validateForms = () => {

    if (changeOptions.value.length > 1 && choosedOptions.value.length <= 0) {
        return "未勾選要申請的項目，請確認！";
    }

    let needValidList = benefitsList.value.filter(e => choosedOptions.value.includes(e.key))
    for (const typeData of needValidList) {                //保險類別
        if (typeData.order.length === 0) {
            return `${typeData.title} 受益人未填寫任何資料，請確認！`;
        } else {
            for (const orderData of typeData.order) {           //第N順位  
                if (!orderData.isEqual) { // 非均分要檢查比例是否加總100
                    let sum = 0;
                    (orderData.order).forEach(data => {
                        sum += parseFloat(getItemRatio(data.fields));
                    });
                    if (sum !== 100.00) {
                        return "受益人分配方式填寫不完整，請確認！"
                    }
                }
                for (const personalData of orderData.order) {   //同順位
                    let realtion = personalData.fields.find(field => field.id === 'relation')?.value;
                    let name;
                    for (const field of personalData.fields) {  //檢查每一項欄位
                        if (field.id === 'mobile') { continue; }
                        if (realtion === '法定繼承人' && (field.id === 'id' || field.id === 'birthday' || field.id === 'engName')) { 
                            console.log(field.value);
                            // 清空ID欄位
                            if(realtion === '法定繼承人' && field.id === 'id') {
                                field.value = '';
                            }
                            // 清空英文名稱
                            if(realtion === '法定繼承人' &&  field.id === 'engName') {
                                field.value = '';
                            }
                            // 清空生日
                            if(realtion === '法定繼承人' &&  field.id === 'birthday') {
                                field.value = '';
                            }
                            continue; 
                        }
                        if (field.id === 'name') {
                            if (!field.value) {
                                return "受益人姓名未填寫，請確認！"
                            } else {
                                name = field.value;
                            }
                        }

                        if (field.id === 'accountGroup' ) {
                            if(field.value.bankAccount !== '' && field.value.bankBranch == '') {
                                return `受益人 ${name} 銀行帳號未填寫完整，請確認！`
                            }
                        }

                        if (typeof field.value === 'string' && field.value === '') {
                            return `受益人 ${name} ${field.key} 未填寫，請確認！`
                        }
                        if (typeof field.value === 'object' && (field.value.bankCode !== '' && field.value.bankAccount === '')) {
                            return `受益人 ${name} 銀行帳號未填寫完整，請確認！`
                        }
                        if (typeof field.value === 'object' && (Boolean(field.value.city) && field.value.address === '')) {
                            return `受益人 ${name} 聯絡地址未填寫完整，請確認！`
                        }
                        if (field.errorMassage !== '') {
                            return field.errorMassage
                        }
                    }
                }
            }
        }
    }

}


/**
 * API
 */
//取關係列表選單
const fetchRelation = async () => {
    isLoading.value = true;
    try {
        const resp = await postRelation4();
        relationList.value = resp.data.relationList;
    } catch (e) {
        console.log(e);
    } finally {
        isLoading.value = false;
    }
};
//取受益人資料
const fetchInfo = async () => {
    isLoading.value = true;
    try {
        const resp = await getInfo();
        const respData = resp.data;
        // const respData = testInfo.value;
        hasForeignCurrency.value = respData.foreignCurrency;

        const groupedData1 = setOrderData(respData.beneficiary01);
        const groupedData2 = setOrderData(respData.beneficiary02);
        const groupedData3 = setOrderData(respData.beneficiary03);
        isDeathAnnuity.value = Boolean(respData?.isDeathAnnuity === 'Y');

        const result = [
            {
                title: isDeathAnnuity.value ? '身故後年金' : '身故保險金', order: groupedData1, key: '005_01'
            },
            {
                title: '生存保險金', order: groupedData2, key: '005_02'
            },
            {
                title: '滿期保險金', order: groupedData3, key: '005_03'
            },
        ];
        respData.beneficiaries.forEach((item, i) => {
            if (item === 'Y') {
                benefitsList.value.push(result[i]);
                changeOptions.value.push({ title: result[i].title, key: result[i].key })
            }
        });

        // 單種保險金送出
        if (changeOptions.value.length === 1) {
            choosedOptions.value.push(changeOptions.value[0].key)
        }

        console.log(benefitsList.value);
        if (benefitsList.value.length === 0) {
            $vfm.show({
                component: 'DialogBase',
                params: {
                    title: '無可填寫之受益人表單',
                    content: '您的保單暫時無法提供線上保單服務，請通知您的服務人員協助辦理，或洽詢免付費服務電話0809-000-550，造成您的不便，敬祈見諒。',
                    confirmButton: '確定',
                    cancelButton: null,
                    closeicon: false,
                },
                on: {
                    confirm() {
                        router.push({ name: routeName.CLOUD_E_COUNTER_HOME });
                    },
                }
            });
        }
    } catch (e) {
        console.log(e);
    } finally {
        isLoading.value = false;
    }
};

const getCityData = async () => {
    const result = await getCityInfo();
    cityInfo.countyList = result.data.cityInfoList.reduce((group, item) => {
        const { city } = item;
        group[city] = group[city] || [];
        //group[city].push({ ...item, showText: item.area });
        group[city].push({ ...item, showText: `${item.zip} ${item.area}` });
        return group;
    }, {});
    cityInfo.cityList = Object.keys(cityInfo.countyList);
    Object.values(cityInfo.countyList).forEach(item => {
        item.forEach(i => {
            i.value = i.area;
        });
    });;
}

const setCityValue = (item) => {
    item.cityArea = '';
    item.address = '';
};

const setCityArea = (item) => {
    item.address = '';
};

const initData = async () => {
    if (store.state.services?.changeItemsResult[code]?.benefitsList) {
        const storedData = store.state.services.changeItemsResult[code].benefitsList;
        benefitsList.value = storedData;
        changeOptions.value = store.state.services.changeItemsResult[code].changeOptions;
        choosedOptions.value = store.state.services.changeItemsResult[code].choosedOptions;
        isDeathAnnuity.value = store.state.services.changeItemsResult[code].isDeathAnnuity;
        hasForeignCurrency.value = store.state.services.changeItemsResult[code].hasForeignCurrency;
        store.dispatch('services/setChangeItemsResult', { code, value: null });
    } else {
        await fetchInfo();
    }
}

/**
 * Hook
 */
onMounted(async () => {
    await fetchRelation();
    //await fetchInfo();
    await initData();
    await getCityData();
});

watch(() => sameOrderList.value, () => {
    sameOrderList.value?.forEach(item => {
        checkComplete(item);
    });
}, { immediate: true, deep: true });

</script>

<style scoped></style>
